//Copied from the components folder, this will replace the other one when the time comes
import TagInput from './TagInput';
export default TagInput;
